var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('viewer',{attrs:{"images":_vm.viewerList}},_vm._l((_vm.viewerList),function(src){return _c('img',{key:src.id,staticStyle:{"height":"120px","margin-right":"5px","max-width":"100%","vertical-align":"middle"},attrs:{"src":src.url}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }